import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../consts";
import {MAX_RESULTS_FOR_RECENT_SEARCHES} from "../app/consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {NewSearchWidgetRecentSearchesEntityModel} from "../../widgets/new-search-widget/models/new-search-widget.recent-searches-entity.model";

export class SearchStorageEntityHandler extends ActionHandler {
  type = ACTION_TYPES.storageEntity;
  localStorageUtils: LocalStorageUtils;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  async action(props) {
    const recentSearches: Array<NewSearchWidgetRecentSearchesEntityModel> = this.getEntitiesFromStorage();
    const newEntity: NewSearchWidgetRecentSearchesEntityModel = new NewSearchWidgetRecentSearchesEntityModel(props.item.id, props.item.objectType);
    let filteredRecentSearches: Array<NewSearchWidgetRecentSearchesEntityModel> = recentSearches.filter((entity: NewSearchWidgetRecentSearchesEntityModel) => (entity.id !== newEntity.id || entity.type !== newEntity.type));

    const maxEntities: Number = MAX_RESULTS_FOR_RECENT_SEARCHES
    filteredRecentSearches = filteredRecentSearches.slice(0, (maxEntities - 1));
    filteredRecentSearches.unshift(newEntity);
    this.setEntityToStorage(filteredRecentSearches);
  }

  getEntitiesFromStorage(): Array<NewSearchWidgetRecentSearchesEntityModel> {
    const recentSearches: Array<NewSearchWidgetRecentSearchesEntityModel> = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.recentSearches) || [];

    return recentSearches;
  }

  setEntityToStorage(items): * {
    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.recentSearches, items);
  }
}


